import { colors } from '../../../../../../packages';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  drawer: {
    '& .drawerBody': {
      padding: 0,
    },
  },
  wrapper: {
    flex: 1,
    justifyItems: 'space-between',
    flexDirection: 'column',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 80,
    padding: '20px 16px',
    borderBottom: `1px solid ${colors.neutral100}`,
  },
  headerTitle: {
    fontSize: 24,
    lineHeight: '32px',
    fontWeight: 700,
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 80,
    padding: 16,
    borderTop: `1px solid ${colors.neutral100}`,
  },
  backBtn: {
    width: 40,
    height: 40,
    minWidth: 40,
  },
  form: {
    flex: 1,
  },
  formContent: {
    flex: 1,
    display: 'flex',
    minHeight: 'calc(100vh - 160px)',
    flexDirection: 'column',
    gap: 24,
    padding: 40,
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    position: 'relative',
  },
  label: {
    fontSize: 14,
    lineHeight: '20px',
    margin: 0,
  },
  startAdorment: {
    marginRight: '28px !important',
    '&::after': {
      content: '"" !important',
      position: 'absolute',
      backgroundColor: colors.neutral25,
      borderRight: `1px solid ${colors.neutral100}`,
      width: 40,
      height: 52,
      left: -16,
      top: -16,
      bottom: -32,
      zIndex: '-1 !important',
    },
  },
  endAdorment: {
    marginLeft: '28px !important',
    '&::after': {
      content: '"" !important',
      position: 'absolute',
      backgroundColor: colors.neutral25,
      borderLeft: `1px solid ${colors.neutral100}`,
      width: 60,
      height: 52,
      right: -16,
      top: -16,
      bottom: -32,
      zIndex: '-1 !important',
    },
  },
  timeBasedSection: {
    gap: 16,
    padding: 16,
    borderRadius: 8,
    border: `1px solid ${colors.neutral100}`,
  },
  addBtn: {
    fontSize: 14,
    lineHeight: '20px',
    fontWeight: 700,
    marginTop: 16,
    '& svg': {
      width: 18,
      marginRight: 6,
    },
  },
  removeBtn: {
    color: colors.destructive600,
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '20px',
  },
});
